export default __webpack_public_path__ + "6375e2868d7b191d5108c7f473267e66.png";